import { render, staticRenderFns } from "./ModelsServices.vue?vue&type=template&id=254cff1a"
import script from "./ModelsServices.vue?vue&type=script&lang=js"
export * from "./ModelsServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports